import Grid from 'infrastructure/js/components/Grid/gridWrapper';
import CheckMarkCell from '../../../../../Common/CustomGridCells/CheckMarkCell/checkMarkCell';
import { gridsNames } from '../../../../../../enums/gridsNames';

import './truckSensorsViewGrid.scss';

const filterConfig = [
  { fieldName: 'businessId', filterName: 'businessId', getOptions: true },
  { fieldName: 'providerType', filterName: 'sensorProvider', getOptions: true },
  { fieldName: 'defaultProvider', filterName: 'defaultProvider', getOptions: true },
];

export default function truckSensorsViewGrid({ actions }) {
  const columnsConfig = [
    {
      fieldName: 'businessId',
      title: 'Configuration Name',
      filterType: 'MULTI_SELECT',
      filterName: 'businessId',
      columnOptions: {
        cellComponent: 'LabelWithTooltipCell',
      },
    },
    {
      fieldName: 'providerType',
      title: 'Sensor Provider',
      filterType: 'MULTI_SELECT',
      filterName: 'sensorProvider',
      columnOptions: {
        cellComponent: 'LabelWithTooltipCell',
      },
    },
    {
      fieldName: 'defaultProvider',
      title: 'Default Provider',
      filterType: 'MULTI_SELECT',
      filterName: 'defaultProvider',
      columnOptions: {
        cellComponent: CheckMarkCell,
      },
    },
  ];

  return (
    <div className="trucks-sensors-grid ">
      <Grid
        gridName={gridsNames.ADMINISTRATION_SETTINGS_TRUCKS_SENSORS}
        columnsConfig={columnsConfig}
        actions={actions}
        filterConfig={filterConfig}
      />
    </div>
  );
}